const getChannelAcceptedTypes = (channel: string, isManychatApi: boolean) => {
    if (channel === 'instagram' && isManychatApi) return 'image/*';
    if (channel === 'whatsapp' && isManychatApi) return '';
    if (channel === 'tiktok' && isManychatApi) return '';
    return 'image/*,audio/*,video/mp4,application/x-pdf';
};

export default getChannelAcceptedTypes;
